import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { DatosAdicionales } from '../../models/datos-adicionales';

@Component({
  selector: 'datos-adicionales',
  templateUrl: './datos-adicionales.component.html',
  styleUrls: ['./datos-adicionales.component.css']
})
export class DatosAdicionalesComponent implements OnInit {
  	@Input() public datos: Array<DatosAdicionales>;
  	public modalRef: BsModalRef;
    public dato: DatosAdicionales;
    public loading: boolean = false;

	constructor(
		private modalService: BsModalService,
	) { 
		this.dato = new DatosAdicionales();
	}

	ngOnInit() {
    }
    
    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
    }

	addDatos(){
        this.datos.push(this.dato);
        this.dato = new DatosAdicionales();
    }

    isDatosValidForm(){
        if( this.dato.valor == ""){
            return false;
        }
        if( this.dato.descripcion == ""){
            return false;
        }
        return true;
    }

    onDeleteDatos(i){
        this.datos.splice(i, 1);
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/controls/datos-adicionales/datos-adicionales.component.ts